import React, { useState, useEffect } from "react";
import { Modal, Form, Button, Row, Col } from "react-bootstrap";

const MaskTransactionModal = ({ show, onHide, transaction, onSubmit }) => {
  const [note, setNote] = useState("");

  useEffect(() => {
    if (transaction) {
      setNote(transaction.note || "");
    }
  }, [transaction]);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({ note });
  };

  if (!transaction) return null;

  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Edit Transaction - {transaction.orderId}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          {/* Order Info */}
          <Row className="mb-3">
            <Col md={4}>
              <Form.Group>
                <Form.Label>Order ID</Form.Label>
                <Form.Control
                  type="text"
                  value={transaction.orderId || "-"}
                  readOnly
                />
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group>
                <Form.Label>Date</Form.Label>
                <Form.Control
                  type="text"
                  value={transaction.datetime}
                  readOnly
                />
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group>
                <Form.Label>Activity</Form.Label>
                <Form.Control
                  type="text"
                  value={transaction.activity}
                  readOnly
                />
              </Form.Group>
            </Col>
          </Row>

          {transaction.activity === "Borrow" && transaction.dueDateFormatted && (
            <Row className="mb-3">
              <Col md={4}>
                <Form.Group>
                  <Form.Label>Due Date</Form.Label>
                  <Form.Control
                    type="text"
                    value={transaction.dueDateFormatted}
                    readOnly
                  />
                </Form.Group>
              </Col>
            </Row>
          )}

          <hr />

          {/* Items List */}
          <h5 className="mb-3">Items</h5>
          <div className="table-responsive mb-3">
            <table className="table table-sm table-bordered">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Mask Name</th>
                  <th>Size</th>
                  <th>Qty</th>
                  {transaction.activity === "Rent" && <th>Price</th>}
                </tr>
              </thead>
              <tbody>
                {transaction.items && transaction.items.length > 0 ? (
                  transaction.items.map((item, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{item.maskName || "-"}</td>
                      <td>{item.size || "-"}</td>
                      <td>{item.amount}</td>
                      {transaction.activity === "Rent" && (
                        <td>{item.price ? `${item.price.toLocaleString()} THB` : "-"}</td>
                      )}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td>1</td>
                    <td>{transaction.maskName || "-"}</td>
                    <td>{transaction.size || "-"}</td>
                    <td>{transaction.amount}</td>
                    {transaction.activity === "Rent" && (
                      <td>{transaction.price ? `${transaction.price.toLocaleString()} THB` : "-"}</td>
                    )}
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <hr />

          {/* Patient Info (Read-only) */}
          <h5 className="mb-3">Patient Information</h5>
          <Row className="mb-3">
            <Col md={3}>
              <Form.Group>
                <Form.Label>HN</Form.Label>
                <Form.Control
                  type="text"
                  value={transaction.HN || "-"}
                  readOnly
                />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label>First Name</Form.Label>
                <Form.Control
                  type="text"
                  value={transaction.firstname || "-"}
                  readOnly
                />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label>Last Name</Form.Label>
                <Form.Control
                  type="text"
                  value={transaction.lastname || "-"}
                  readOnly
                />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label>Mobile</Form.Label>
                <Form.Control
                  type="text"
                  value={transaction.mobile || "-"}
                  readOnly
                />
              </Form.Group>
            </Col>
          </Row>

          <hr />

          {/* Note (Editable) */}
          <Form.Group className="mb-3">
            <Form.Label>Note</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={note}
              onChange={(e) => setNote(e.target.value)}
              placeholder="Add notes..."
            />
          </Form.Group>

          <div className="d-flex justify-content-end">
            <Button variant="secondary" onClick={onHide} className="mr-2">
              Cancel
            </Button>
            <Button variant="primary" type="submit">
              Save Changes
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default MaskTransactionModal;
